// extracted by mini-css-extract-plugin
export default {"contentWrap":"CompanyInfo_contentWrap__lvQgb"};